import React from "react";
import { StyledModal } from "./styles";

interface IModal {
  className?: string;
  handleClose: () => void;
  isShow: boolean;
  children?: React.ReactNode;
}

const Modal: React.FC<IModal> = ({
  className,
  handleClose,
  isShow,
  children
}) => {
  const toggleShow = isShow ? "m-modal show" : "m-modal hide";

  return (
    <StyledModal className={`${toggleShow} ${className}`} onClick={handleClose}>
      <section onClick={(event) => event.stopPropagation()}>
        {children}
        <button onClick={handleClose}>&#10005;</button>
      </section>
    </StyledModal>
  );
};

export default Modal;
